import { TextField } from '@mi-front/ui';
import { Button, Grid } from '@mui/material';
import { useField } from 'formik';
import { FormattedMessage } from 'react-intl';

export const MentionFromCustomField = () => {
  const [, , { setValue }] = useField('source');

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            name="mentionCustom.name"
            label={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}
            hint={
              <div>
                <Button
                  sx={{ marginLeft: -1.25, marginTop: -0.5 }}
                  variant="text"
                  size="small"
                  onClick={() => setValue('schedules')}
                >
                  <FormattedMessage
                    id="audit.liveMentions.selectFromSchedules"
                    defaultMessage="Seleccionar una mención desde schedules"
                  />
                </Button>
              </div>
            }
            markRequired
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            name="mentionCustom.description"
            label={<FormattedMessage id="common.text.description" defaultMessage="Descripción" />}
          />
        </Grid>
      </Grid>
    </div>
  );
};
